import { createContext } from 'react';

const RefreshMenuItemContext = createContext();

export default RefreshMenuItemContext;
